var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 12.3232H4.875C4.65292 12.3232 4.46875 12.1391 4.46875 11.917C4.46875 11.6949 4.65292 11.5107 4.875 11.5107H11.375C11.5971 11.5107 11.7813 11.6949 11.7813 11.917C11.7813 12.1391 11.5971 12.3232 11.375 12.3232Z",
    fill: "#023452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62509 12.3012C4.08342 12.3012 3.56886 12.09 3.18969 11.7054L1.28844 9.80416C0.497604 9.01333 0.497604 7.72417 1.28844 6.93333L6.93802 1.28375C7.70177 0.52 9.04509 0.52 9.80884 1.28375L11.7101 3.185C12.5009 3.97583 12.5009 5.265 11.7101 6.05583L6.06052 11.7054C5.68135 12.0954 5.17217 12.3012 4.62509 12.3012ZM1.8626 9.23542L3.76386 11.1367C4.22427 11.5971 5.03135 11.5971 5.48635 11.1367L11.1359 5.48708C11.6126 5.01041 11.6126 4.24125 11.1359 3.76458L9.23468 1.86333C8.77968 1.40833 7.9726 1.40292 7.51218 1.86333L1.8626 7.51292C1.38594 7.98417 1.38594 8.75875 1.8626 9.23542Z",
    fill: "#023452"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05397 9.55008C7.95105 9.55008 7.84815 9.51216 7.7669 9.43091L3.56898 5.233C3.4119 5.07591 3.4119 4.81591 3.56898 4.65883C3.72607 4.50174 3.98607 4.50174 4.14315 4.65883L8.34107 8.85674C8.49815 9.01383 8.49815 9.27383 8.34107 9.43091C8.25982 9.51216 8.15688 9.55008 8.05397 9.55008Z",
    fill: "#023452"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90686 9.97171C1.80395 9.97171 1.70102 9.93379 1.61977 9.85254C1.46268 9.69546 1.46268 9.43545 1.61977 9.27837L4.68562 6.21254C4.8427 6.05546 5.1027 6.05546 5.25978 6.21254C5.41687 6.36962 5.41687 6.62962 5.25978 6.7867L2.19393 9.85254C2.11268 9.93379 2.00978 9.97171 1.90686 9.97171Z",
    fill: "#023452"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43421 11.5049C3.33129 11.5049 3.22836 11.467 3.14711 11.3857C2.99003 11.2287 2.99003 10.9687 3.14711 10.8116L6.21293 7.74574C6.37001 7.58866 6.63004 7.58866 6.78713 7.74574C6.94421 7.90283 6.94421 8.16282 6.78713 8.31991L3.72127 11.3857C3.64544 11.4616 3.54254 11.5049 3.43421 11.5049Z",
    fill: "#023452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8332c941e8a6bfa0c03f3e48820b74a6.svg";
export { ForwardRef as ReactComponent };